export default "__VITE_ASSET__d5501f1b__"